import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import type { DeclinedActivityDetails } from '@paintscout/api'
import Highlight from '@paintscout/ui/components/Highlight'
import Typography from '@paintscout/ui/components/Typography'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import ActivityContent from '../ActivityContent'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import QuoteLabel from '../QuoteLabel'
import ActivityContact from '../ActivityContact'
import ActivityDot from '../ActivityDot'

const useStyles = makeStyles<Theme, ActivityTypeComponentProps<DeclinedActivityDetails>>((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  reason: {
    color: theme.palette.text.secondary
  }
}))

// the 2nd group will be the reason between quotation marks
const declinedEventRegex = /(Declined for the following reason:\n\n ")(.*)(")/

export default function QuoteDeclinedActivity(props: ActivityTypeComponentProps<DeclinedActivityDetails>) {
  const { activity, showDocTypeDetails } = props
  const classes = useStyles(props)

  const { events } = activity.details
  const declinedEvent = events?.[0]
  // get reason from details, otherwise get 2nd group from regex
  const reason = activity.details.reason ?? declinedEvent?.match(declinedEventRegex)?.[2] ?? ''

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> was <Highlight>Declined</Highlight>
            <ActivityContact activity={activity} />
          </>
        ) : (
          <>
            <Highlight>Declined</Highlight>
          </>
        )}
      </ActivityTitle>
      {reason && (
        <ActivityContent className={classes.content}>
          <Typography variant="subtitle2" className={classes.reason}>
            {`"${reason}"`}
          </Typography>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
